import { render, staticRenderFns } from "./segment-tab.vue?vue&type=template&id=1039c08a&scoped=true"
import script from "./segment-tab.vue?vue&type=script&lang=js"
export * from "./segment-tab.vue?vue&type=script&lang=js"
import style0 from "./segment-tab.vue?vue&type=style&index=0&id=1039c08a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039c08a",
  null
  
)

export default component.exports